module.exports = __webpack_public_path__ + "static/media/mokuroku-home-kitchen1.c57a216e.svg";